import i18n from '@/lang/index'
import { getRegExp } from '@/utils/common'

export default function RETURN_DATA() {
  return {
    // 登录表单 预登录
    LOGIN_FORM: {
      username: '',
      password: ''
    },
    LOGIN_FORM_RULES: {
      username: [{ required: true, message: i18n.t('message.inputRequired'), trigger: ['input', 'change'] }],
      password: [{ required: true, message: i18n.t('message.inputRequired'), trigger: ['input', 'change'] }]
    },
    // 多租户时选择租户
    ACCOUNT_FORM: {
      agentTenantId: ''
    },
    ACCOUNT_FORM_RULES: {
      agentTenantId: [{ required: true, message: i18n.t('message.selectRequired'), trigger: ['input', 'change'] }]
    },
    // 找回密码
    RETRIEVE_FORM: {
      email: '',
      returnUrl: ''
    },
    RETRIEVE_FORM_RULES: {
      email: [
        { required: true, message: i18n.t('message.userEmailRequired'), trigger: ['input', 'change'] },
        { pattern: getRegExp('email'), message: i18n.t('message.userEmailFormat'), trigger: ['input', 'change'] }
      ]
    },
    // 重置密码
    RESET_FORM: {
      sessionId: '',
      password: '',
      password2: ''
    },
    RESET_FORM_RULES: {
      password: [
        { required: true, message: i18n.t('message.inputRequired'), trigger: ['input', 'change'] },
        { pattern: getRegExp('password'), message: i18n.t('message.passwordFormat'), trigger: ['input', 'change'] }
      ],
      password2: [
        { required: true, message: i18n.t('message.inputRequired'), trigger: ['input', 'change'] },
        { pattern: getRegExp('password'), message: i18n.t('message.passwordFormat'), trigger: ['input', 'change'] }
      ]
    },
    // 第三方登录
    THIRD_PARTY_FORM: {
      configId: null
    },
    THIRD_PARTY_FORM_RULES: {
      configId: [{ required: true, message: i18n.t('message.selectRequired'), trigger: ['blur', 'change'] }]
    },
    // 修改密码
    CHANGE_FORM: {
      sessionId: '',
      oldPassword: '',
      password: '',
      password2: ''
    },
    CHANGE_FORM_RULES: {
      oldPassword: [{ required: true, message: i18n.t('message.inputRequired'), trigger: ['input', 'change'] }],
      password: [
        { required: true, message: i18n.t('message.inputRequired'), trigger: ['input', 'change'] },
        { pattern: getRegExp('password'), message: i18n.t('message.passwordFormat'), trigger: ['input', 'change'] }
      ],
      password2: [
        { required: true, message: i18n.t('message.inputRequired'), trigger: ['input', 'change'] },
        { pattern: getRegExp('password'), message: i18n.t('message.passwordFormat'), trigger: ['input', 'change'] }
      ]
    }
  }
}
